import InsureProcessFire from './InsureProcessFire';
export default InsureProcessFire;
